import type { ComponentType } from "react";

import {
  AwsLogo,
  AzureLogo,
  DefaultLogo,
  GcpLogo,
  type IconWithSizeProps,
} from "@stacklet/ui";

/** Maps an identity provider type to its logo. */
const IDP_LOGOS: Record<string, ComponentType<IconWithSizeProps>> = {
  AWS: AwsLogo,
  GCP: GcpLogo,
  Azure: AzureLogo,
};

/** Props for the IdentityProviderLogo component */
interface Props extends IconWithSizeProps {
  /** The `idpType` of the provider the logo stands for */
  idpType: string;
}

/**
 * The logo for an identity provider type. SAML providers have no cloud logo,
 * and the fallback also covers any provider type Relay surfaces as `%other`.
 */
export function IdentityProviderLogo({ idpType, ...iconProps }: Props) {
  const Logo = IDP_LOGOS[idpType] ?? DefaultLogo;

  return <Logo {...iconProps} />;
}
